import { render, staticRenderFns } from "./AllotEditor.vue?vue&type=template&id=f43163c8"
import script from "./AllotEditor.vue?vue&type=script&lang=js"
export * from "./AllotEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports